import { createFileRoute, redirect } from '@tanstack/react-router'

/** Renamed to Active once resolved threads got lists of their own. */
export const Route = createFileRoute('/_app/$org/$host/outreach/_list/sent')({
  beforeLoad: ({ params, search }) => {
    throw redirect({ to: '/$org/$host/outreach/active', params, search, replace: true })
  },
})
